import AppConfig from '@/config/app'
import BillingStatus from '@/api/billing-status'
import FeeCategory from '@/api/fee-category'
import FeeCategoryBasis from '@/api/fee-category-basis'
import Group from '@/api/group'
import Role from '@/api/role'
import Permission from '@/api/permission'
import Company from '@/api/company'

export default {
  namespaced: true,
  strict: AppConfig.store.strict,
  modules: {
    BillingStatus,
    FeeCategory,
    FeeCategoryBasis,
    Group,
    Role,
    Permission,
    Company
  }
}
